import type { PDFWriter } from "@pdfking/renderer-api"
import type { PdfiumApi } from "@pdfking/renderer-wasm-pdfium"

import { CopyPage } from "../functions/CopyPage"
import { GetLastError } from "../functions/GetLastError"
import { SaveDocument } from "../functions/SaveDocument"
import type { InternalPDFReader } from "../types/InternalTypes"

export const CreatePDFWriter = async (api: PdfiumApi): Promise<PDFWriter> => {
  const doc_pointer = await api.safeCall("FPDF_CreateNewDocument")

  if (!doc_pointer) {
    const error = await GetLastError(api.call)
    throw error ?? new Error("Failed to create new PDF document")
  }

  const close = async () => {
    if (doc_pointer) {
      await api.call("FPDF_CloseDocument", doc_pointer)
    }
  }

  return {
    async insert(source: InternalPDFReader, insert_at: number): Promise<void> {
      const pageCount = await source.page_count()
      if (pageCount !== 1) {
        throw new Error(`Expected source to have 1 page, got ${pageCount}`)
      }

      await CopyPage(api, source.doc_pointer, doc_pointer, insert_at)
    },

    save(): AsyncGenerator<Blob> {
      return SaveDocument(api, doc_pointer)
    },

    close,
  }
}
